export const BOUNDARY_SPACE = 360
export const BOUNDARY_LEFT_POSITION = 'left'
export const BOUNDARY_RIGHT_POSITION = 'right'

export const MAX_BUILDING_FLOORS = 20
